<template>
  <div class="content-width">
    <div>
      <h2><i class="el-icon-error"></i> Sorry, we are unable to show the agreement</h2>
      <p>The support team has been alerted and we will fix this issue immediately.</p>
    </div>

    <sh-spacer :by="1" />

    <p>
      Please contact the support for any urgent matter.
      <el-button @click="openSupport">Contact support</el-button>
    </p>
  </div>
</template>

<script>
export default {
  methods: {
    openSupport() {
      this.$store.commit('dialogue/open', 'support');
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/Licenses/Others/AgreementFallback.vue